import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicePage = lazy(() => import('../pages/service/page'));
const ServiceConsultingPage = lazy(() => import('../pages/service/consulting/page'));
const ServiceManagerPage = lazy(() => import('../pages/service/manager/page'));
const ServiceTrainingPage = lazy(() => import('../pages/service/training/page'));
const AiToolPage = lazy(() => import('../pages/service/ai-tool/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const MemberPage = lazy(() => import('../pages/member/page'));
const RecruitPage = lazy(() => import('../pages/recruit/page'));
const CasesPage = lazy(() => import('../pages/cases/page'));
const CaseDetailPage = lazy(() => import('../pages/cases/detail/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news/detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PhilosophyPage = lazy(() => import('../pages/philosophy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const SecurityPage = lazy(() => import('../pages/security/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/service', element: <ServicePage /> },
  { path: '/service/consulting', element: <ServiceConsultingPage /> },
  { path: '/service/manager', element: <ServiceManagerPage /> },
  { path: '/service/training', element: <ServiceTrainingPage /> },
  { path: '/service/ai-tool', element: <AiToolPage /> },
  { path: '/company', element: <CompanyPage /> },
  { path: '/member', element: <MemberPage /> },
  { path: '/recruit', element: <RecruitPage /> },
  { path: '/cases', element: <CasesPage /> },
  { path: '/cases/:id', element: <CaseDetailPage /> },
  { path: '/news', element: <NewsPage /> },
  { path: '/news/:id', element: <NewsDetailPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/philosophy', element: <PhilosophyPage /> },
  { path: '/faq', element: <FaqPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/security', element: <SecurityPage /> },
  { path: '*', element: <NotFoundPage /> },
];

export default routes;